import { Button } from "primereact/button";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import appActions from "../../../appActions";
import { TabPanel, TabView } from "primereact/tabview";
import { Dropdown } from "primereact/dropdown";

const Dashboard = () => {

    const dispatch = useDispatch();

    const fileGroupStats = useSelector((state) => state.dashboard.fileGroupStats);
    const filePjoStats = useSelector((state) => state.dashboard.pjoStats);
    const sysStoreList = useSelector((state) => state.sysStore.sysstoreList || []);

    const storeOptions = sysStoreList?.data?.map((store) => ({
        label: `${store.storeId} : ${store.title}`,
        value: store.storeId,
    })) || [];

     const getDefaultParams = (filters = {}) => ({
        ...filters,
        sort: 'createdOn',
         sortOrder: -1,
        status: 'Active'
    });

    const defaultParamsStoreFilter = useMemo(() => getDefaultParams(), []);

    const [activeIndex, setActiveIndex] = useState(0);
    const [storeId, setStoreId] = useState("");


    const [lastSynceDateTime, setLastSynceDateTime] = useState(null);
    
    const defaultParams = useMemo(() => ({
        templateTypes: "PJO,FGPT,FGPM,IPRT,CPNT,CBT,MCT,EIT,ITT,RECT,ILT,FGM,MSM,PJOA,PJOC",
        storeId
    }), [storeId]);

    useEffect(() => {
        dispatch(appActions.SYSSTORE_GET_ALL_REQUEST(defaultParamsStoreFilter));
        dispatch(appActions.DASHBOARD_GET_STATS_REQUEST(defaultParams));
        dispatch(appActions.DASHBOARD_GET_PJO_STATS_REQUEST({storeId : storeId}));
        setLastSynceDateTime(new Date().toISOString()); // Set last sync time
    }, [dispatch, storeId, defaultParams, defaultParamsStoreFilter]);

    const getFileState = useCallback(() => {
        dispatch(appActions.DASHBOARD_GET_STATS_REQUEST(defaultParams));
        setLastSynceDateTime(new Date().toISOString()); // Set last sync time
    }, [dispatch, defaultParams]);

    const getPjoState = useCallback(() => {
        dispatch(appActions.DASHBOARD_GET_PJO_STATS_REQUEST({storeId : storeId}));
        setLastSynceDateTime(new Date().toISOString()); // Set last sync time
    }, [dispatch, storeId]);

    const handleRefresh = () => {
        getFileState()
        getPjoState()
    };

    const renderHeader = () => (
         <div className="flex flex-row gap-10 align-items-center">
            <h1 className="text-xl font-bold">Dashboard</h1>
            <Button icon="pi pi-sync" className="p-button-rounded p-button-text mr-auto" onClick={handleRefresh} />
            <small className="text-sm text-gray-500 f-right "><strong>Last template received: </strong> {lastSynceDateTime}</small>
        </div>
    );

    const renderCards = () => (
        <div className="grid">
            { filePjoStats && fileGroupStats?.map((group, index) => (
                <div key={index} className="col-6">
                    <div className=" bg-white shadow-white pv-15 ph-15 mb-2">

                    <h2 className="text-lg font-semibold">{group?.fileGroup} {group?.lastCreatedDate &&  <small className="text-sm text-gray-500 f-right"> <strong>Last template received: </strong> {group?.lastCreatedDate}</small> }</h2>
            
                    <div className="flex flex-row gap-10 fill-flex">
                        
                        <div className="flex flex-column justify-content-start stats-wrapper">
                            <h1 className="stats-count">{group?.totalCount}</h1>
                            <h5 className="stats-title">Total Count</h5>
                        </div>

                        <div className="flex flex-column justify-content-start stats-wrapper">
                            <h1 className="stats-count">{group?.receivedCount}</h1>
                            <h5 className="stats-title">Received</h5>
                        </div>

                        <div className="flex flex-column justify-content-start stats-wrapper">
                            <h1 className="stats-count">{group?.convertedCount}</h1>
                            <h5 className="stats-title">Converted</h5>
                        </div>

                        <div className="flex flex-column justify-content-start stats-wrapper">
                            <h1 className="stats-count">{group?.uploadedCount}</h1>
                            <h5 className="stats-title">Uploaded</h5>
                        </div>

                        <div className={`flex flex-column justify-content-start stats-wrapper ${group?.error === 'Y' ? 'error-class' : ''}`}>

                            <h1 className="stats-count">{group?.errorCount}</h1>
                            <h5 className="stats-title">Errors</h5>
                        </div>
                        </div>
                     </div>
                    
                </div>
            ))}
        </div>
    );

const renderPjoCards = () => (
    <div className="grid">
        {Array.isArray(filePjoStats) && filePjoStats.length > 0 ? (
            filePjoStats.map((group, index) => (
                <div key={index} className="col-12">
                    <div className="bg-white shadow-white pv-15 ph-15 mb-2">
                        <h2 className="text-lg font-semibold">
                            Store Id: {group?.storeId}{" "}
                            {group?.lastCreatedDate && (
                                <small className="text-sm text-gray-500 f-right">
                                    <strong>Last template received: </strong> {group?.lastCreatedDate}
                                </small>
                            )}
                        </h2>

                        <div className="flex flex-row gap-10 fill-flex">
                            <div className="flex flex-column justify-content-start stats-wrapper">
                                <h1 className="stats-count">{group?.count}</h1>
                                <h5 className="stats-title">Total Count</h5>
                            </div>

                            <div className="flex flex-column justify-content-start stats-wrapper">
                                <h1 className="stats-count">{group?.pjoxmlStatusY}</h1>
                                <h5 className="stats-title">PJO XML Status Yes</h5>
                            </div>

                            <div className="flex flex-column justify-content-start stats-wrapper">
                                <h1 className="stats-count">{group?.pjoxmlStatusN}</h1>
                                <h5 className="stats-title">PJO XML Status No</h5>
                            </div>

                            <div className="flex flex-column justify-content-start stats-wrapper">
                                <h1 className="stats-count">{group?.eodxmlStatusY}</h1>
                                <h5 className="stats-title">EOD XML Status Yes</h5>
                            </div>

                            <div className="flex flex-column justify-content-start stats-wrapper">
                                <h1 className="stats-count">{group?.eodxmlStatusN}</h1>
                                <h5 className="stats-title">EOD XML Status No</h5>
                            </div>

                            <div className="flex flex-column justify-content-start stats-wrapper">
                                <h1 className="stats-count">{group?.tlogExtApiErrorY}</h1>
                                <h5 className="stats-title">Tlog Ext API Error Yes</h5>
                            </div>

                            <div className="flex flex-column justify-content-start stats-wrapper">
                                <h1 className="stats-count">{group?.tlogExtApiErrorN}</h1>
                                <h5 className="stats-title">Tlog Ext API Error No</h5>
                            </div>

                            <div className="flex flex-column justify-content-start stats-wrapper">
                                <h1 className="stats-count">{group?.errorY}</h1>
                                <h5 className="stats-title">Error Yes</h5>
                            </div>

                            <div className="flex flex-column justify-content-start stats-wrapper">
                                <h1 className="stats-count">{group?.errorN}</h1>
                                <h5 className="stats-title">Error No</h5>
                            </div>
                        </div>
                    </div>
                </div>
            ))
        ) : (
            <div className="col-12 text-center text-gray-500 py-5">
                No data available
            </div>
        )}
    </div>
);

    return (
      <div className="form_height">
            <div className='pv-15 ph-15'>
                    {renderHeader()}
            </div>

            <div className="flex flex-row gap-10 justify-content-end align-items-center mt-2 mb-2 pv-15 ph-15">
                <label htmlFor="storeId">Store ID</label>
                <Dropdown filter value={storeId}
                    onChange={(e) => setStoreId( e.value) }
                    options={storeOptions}
                    placeholder="Select a storeid"
                    id='storeId'
                    name='storeId'
                    style={{ width: '200px' }}
                />
            </div>
            <div className="mx-3 br-6s">
                <TabView activeIndex={activeIndex} onTabChange={(e) => { e.index === 0 ? getFileState() : getPjoState(); setActiveIndex(e.index) }}>
                    <TabPanel header="Integration File Stats" leftIcon="pi pi-file mr-2">
                        {renderCards()}    
                    </TabPanel>    
                    <TabPanel header="POS Journal File Stats" leftIcon="pi pi-shopping-bag mr-2">
                        {renderPjoCards()}    
                    </TabPanel>    
                </TabView>
            </div>

        </div>
    );
};

export default Dashboard;